export default __webpack_public_path__ + "static/optional_steps_space_cooling_and_heating-9dda0aeba5ec42d63307c8d522329720.png";